export default {
  fixed: 'FIXNÉ',
  variable: 'Variabilné',
};
